import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class MLService {
    constructor(private apiHttp: ApiHttp) {
    }

    public uploadReceiptPdf(data: FormData, messageService: MessageService): Promise<any> {
        const timeout = 180000; // 3 minutes

        return Promise.race([
            this.apiHttp.post('api/XpressML/UploadReceiptPdf', data, messageService),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Request timeout')), timeout)
            )
        ]);
    }

    public downloadCsv(csvUrl: string, messageService?: MessageService): Promise<any> {
        const encodedUrl = encodeURIComponent(csvUrl);
        return this.apiHttp.postDownloadFile(
            `api/XpressML/DownloadCsv?csvUrl=${encodedUrl}`,
            null,
            messageService
        );
    }
}

